import React from "react"
import { Box, Typography } from "@mui/material"

export const KPI_TILE_SX = {
  border: "1px solid #e2e8ee",
  borderRadius: "8px",
  px: 1,
  py: 0.75,
}

export default function KpiTile({
  label,
  value,
  unit,
  valueColor = "#004f7d",
  subValue,
  subValueColor = "#8a98a6",
  sx,
}) {
  return (
    <Box sx={{ ...KPI_TILE_SX, ...sx }}>
      <Typography sx={{ fontSize: "9px", color: "#8a98a6" }}>
        {label}
      </Typography>
      <Typography
        sx={{ fontSize: "12px", fontWeight: 700, color: valueColor }}
      >
        {value}
        {unit ? (
          <Box component="span" sx={{ fontSize: "9px", fontWeight: 500, ml: 0.4 }}>
            {unit}
          </Box>
        ) : null}
      </Typography>
      {subValue && (
        <Typography sx={{ fontSize: "8.5px", color: subValueColor }}>
          {subValue}
        </Typography>
      )}
    </Box>
  )
}
